import { createRoot } from 'react-dom/client'
import App from '@/App'
import { i18nReady } from '@/i18n'
import { clearStaleChunkMark } from '@/lib/lazyModule'
import '@/index.css'

const container = document.getElementById('app')
if (!container) throw new Error('#app root element not found')

// A table's screen is the heaviest chunk a link can land on: start it with the
// language instead of after it (and after the router has matched), one round
// trip less before the first row. The route's lazy import then finds it loaded.
if (/^\/tables\/[^/]+(\/[^/]+)?\/?$/.test(window.location.pathname)) void import('@/pages/table_app/TableScreen')

const root = createRoot(container)
// The visitor's language is its own chunk (i18n/index.ts): render once it is in.
void i18nReady.finally(() => {
  root.render(<App />)
  // Hide the Rails-rendered loader once React has mounted
  const loader = document.getElementById('mainLoader')
  if (loader) loader.style.display = 'none'
})

// This document booted, so whatever chunk was missing before is behind us: the
// next deploy is allowed its own one-shot reload.
clearStaleChunkMark()
